import React from 'react';

const SvgSadEmoji: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45" {...props}>
      <defs>
        <clipPath id="sadEmoji_svg__a">
          <path d="M0 0h45v45H0z" />
        </clipPath>
      </defs>
      <g
        clipPath="url(#sadEmoji_svg__a)"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M15.877 30.057a9.946 9.946 0 0113.076 0" />
        <circle cx={16.5} cy={16.5} r={16.5} transform="translate(6 6)" />
        <path d="M13.076 18.849a3.637 3.637 0 012.8-1.42 3.683 3.683 0 012.8 1.42M26.151 18.849a3.637 3.637 0 012.8-1.42 3.683 3.683 0 012.8 1.42" />
      </g>
    </svg>
  );
};

export default SvgSadEmoji;
